import { BESTEMMINGEN_ARTICLES } from "./journal-bestemmingen";
import { LUCHTHAVEN_ARTICLES } from "./journal-luchthaven";
import { PRAKTISCH_ARTICLES } from "./journal-praktisch";
import { PRIJS_ARTICLES } from "./journal-prijs";
import type { JournalArticle, JournalCategorySlug } from "./journal-types";
import { VERGELIJKEN_ARTICLES } from "./journal-vergelijken";

export type { JournalArticle, JournalCategorySlug } from "./journal-types";

/** Contentclusters van de Journal. Elk cluster heeft een eigen zoekintentie. */
export const JOURNAL_CATEGORIES: {
  slug: JournalCategorySlug;
  label: string;
  description: string;
}[] = [
  {
    slug: "vergelijken",
    label: "Vergelijken",
    description: "Taxi naast trein, openbaar vervoer of de eigen auto: wanneer welke keuze logisch is.",
  },
  {
    slug: "luchthaven",
    label: "Luchthavenvervoer",
    description: "Vertrektijden, parkeren, bagage en reizen met kinderen rondom vluchten.",
  },
  {
    slug: "bestemmingen",
    label: "Bestemmingen",
    description: "Ziekenhuis, station, hotel, stadion of binnenstad: per bestemming andere aandachtspunten.",
  },
  {
    slug: "bagage-en-toegankelijkheid",
    label: "Bagage en toegankelijkheid",
    description: "Kinderen, huisdieren, hulpmiddelen, groepsvervoer en veel bagage.",
  },
  {
    slug: "timing-en-reserveren",
    label: "Timing en reserveren",
    description: "Wanneer boeken, rijden in de nacht of spits, en omgaan met vertraging.",
  },
  {
    slug: "prijs",
    label: "Prijs en facturatie",
    description: "Vaste prijs versus taxameter en zakelijke facturatie met btw.",
  },
  {
    slug: "slim-reizen",
    label: "Slim reizen",
    description: "Wanneer een taxi de slimste keuze is en wat vooraf reserveren u oplevert.",
  },
];

/** Redactie van de Journal. Bewust de organisatie als auteur zolang er geen
 * persoonlijke auteurprofielen zijn aangeleverd. */
export const JOURNAL_AUTHOR = {
  name: "Redactie Taxiritje.nl",
  role: "Planning en klantenservice",
  bio: "De redactie bestaat uit medewerkers van de planning en klantenservice van Taxiritje.nl. Zij schrijven op basis van de ritten die dagelijks worden ingepland en de vragen die klanten stellen over vertrektijden, bagage, prijzen en boekingen.",
} as const;

export const JOURNAL: JournalArticle[] = [
  ...VERGELIJKEN_ARTICLES,
  ...LUCHTHAVEN_ARTICLES,
  ...BESTEMMINGEN_ARTICLES,
  ...PRAKTISCH_ARTICLES,
  ...PRIJS_ARTICLES,
].sort((a, b) => (a.published < b.published ? 1 : -1));

export function findArticle(slug: string) {
  return JOURNAL.find((a) => a.slug === slug);
}

export function articlesByCategory(category: JournalCategorySlug) {
  return JOURNAL.filter((a) => a.category === category);
}

export function categoryLabel(category: JournalCategorySlug) {
  return JOURNAL_CATEGORIES.find((c) => c.slug === category)?.label ?? "Journal";
}

/** Verwante artikelen: eerst hetzelfde cluster, aangevuld met recente artikelen. */
export function relatedArticles(article: JournalArticle, limit = 3) {
  const sameCluster = JOURNAL.filter((a) => a.slug !== article.slug && a.category === article.category);
  const others = JOURNAL.filter((a) => a.slug !== article.slug && a.category !== article.category);
  return [...sameCluster, ...others].slice(0, limit);
}

export function formatJournalDate(iso: string) {
  return new Date(`${iso}T12:00:00Z`).toLocaleDateString("nl-NL", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}
